import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../utils';

const textHighlightVariants = cva(
  'inline-block rounded-lg px-3 py-0.5 font-inherit',
  {
    variants: {
      variant: {
        pink: 'bg-riso-pink text-white',
        blue: 'bg-foreground text-background',
        teal: 'bg-riso-teal text-white',
        amber: 'bg-riso-amber text-foreground',
      },
    },
    defaultVariants: {
      variant: 'pink',
    },
  },
);

export interface TextHighlightProps
  extends
    React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof textHighlightVariants> {}

const TextHighlight = React.forwardRef<HTMLSpanElement, TextHighlightProps>(
  ({ className, variant, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(textHighlightVariants({ variant, className }))}
      {...props}
    />
  ),
);
TextHighlight.displayName = 'TextHighlight';

export { TextHighlight, textHighlightVariants };
